"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForwardRef = void 0;
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useForwardRef = function (ref, initialValue) {
    if (initialValue === void 0) { initialValue = null; }
    var targetRef = react_1.default.useRef(initialValue);
    react_1.default.useEffect(function () {
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(targetRef.current);
        }
        else {
            ref.current = targetRef.current;
        }
    }, [ref]);
    return targetRef;
};
exports.useForwardRef = useForwardRef;
